import { useTruncatedText } from "../../../hooks/useTruncatedText";
import { Testimonial } from "../data/testimonials";
import { StarIcon } from "./icons/StarIcon";

interface Props {
  testimonial: Testimonial;
}

export const TestimonialCard = ({ testimonial }: Props) => {
  const { textRef, isExpanded, isToggleVisible, toggleExpand } =
    useTruncatedText<HTMLSpanElement>(testimonial.excerpt);

  return (
    <article className="flex w-[260px] shrink-0 flex-col gap-2 rounded-2xl bg-[#F5FAFA] px-4 py-6">
      <header className="flex items-center gap-3">
        <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#FFF6CC] text-[16px] font-bold text-[#0D0D0D]">
          {testimonial.authorInitials}
        </span>
        <div className="flex flex-col text-[#0D0D0D]">
          <p className="text-[16px] [font-weight:600] leading-[1.6]">{testimonial.authorName}</p>
          <p className="text-[13px] leading-[1.6] tracking-[0.26px]">{testimonial.date}</p>
        </div>
      </header>

      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-1">
          <StarIcon size={18} color="#05702F" filled />
          <span className="text-[19px] font-bold leading-[1.2] text-[#05702F]">
            {testimonial.rating}/5
          </span>
        </div>
        <p className="flex flex-col text-[13px] leading-[1.6] tracking-[0.26px] text-[#0D0D0D]">
          <span ref={textRef} className={isExpanded ? undefined : "line-clamp-4"}>
            {testimonial.excerpt}
          </span>
          {isToggleVisible && (
            <button
              type="button"
              onClick={toggleExpand}
              aria-expanded={isExpanded}
              className="self-start [font-weight:600] text-[#0D0D0D] underline underline-offset-2"
            >
              {isExpanded ? "Réduire" : "Lire la suite"}
            </button>
          )}
        </p>
      </div>
    </article>
  );
};
